/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react'
import { Row, Col } from 'react-bootstrap';
import PropTypes from "prop-types";
import InputDescription from "../InputDescription/InputDescription";
import './formLabel.scss'

const FormLabel = (props) => {

    const { label, htmlFor, mandatory, description = '' } = props;

    return <div className={'control-label'}>
        <Row className='label-container'>
            <Col xs={description ? 11 : 12}>
                <label htmlFor={htmlFor}>
                    {label}
                    {mandatory && <span> *</span>}
                </label>
            </Col>
            {description && <Col xs={1} className='pr0-pl0'><InputDescription descriptionFor={htmlFor} description={description}></InputDescription></Col>}
        </Row>
    </div>
}


FormLabel.propTypes = {
    /**
     * The name of the associated component (optional)
     */
    name: PropTypes.string,
    /**
     * Name of html element this label is used for (optional)
     */
    htmlFor: PropTypes.string,
    /**
     * The label text
     */
    label: PropTypes.string,
    /**
     * The label style, added as a class (optional)
     */
    labelStyle: PropTypes.string,
    /**
     * A description for info icon (optional)
     */
    description: PropTypes.string,
    /**
     * If true, a '*' is shown to denote a required field (optional)
     */
    mandatory: PropTypes.bool
};

export default FormLabel;
